import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RetailerDetails from '../../components/blocks/RetailerDetails';
import { CymbioSpinner } from '../../components/common/Spinner';
import { putPermissions } from '../../store/actions/permissions';
import { postRetailerErpId, updateShipperAccount } from '../../store/actions/retailer';
import { getWarehouses } from '../../store/actions/warehouses';
import { updateAccountIdConfig } from '../../store/actions/accountId';
import { tiktokToggleConnectionStatus } from '../../constants/featureFlag';
import { alertSuccess } from '../../store/actions/alert';
import { toggleTiktokStatus } from '../../store/actions/channels';
import { CHANNELS } from '../../constants/channels';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { DISABLED } from '../../constants/permissions';

function RetailerDetailsContainer(props) {
  const { retailer, isLoading, supplierId, getWarehouses, isTikTokIntegration, brandIdMapping } = props;
  const isConnectionStatusToggleEnabled = useFeatureFlag(tiktokToggleConnectionStatus, false);

  useEffect(() => {
    getWarehouses();
  }, [getWarehouses, supplierId]);

  if (isLoading || !retailer?.id) {
    return <CymbioSpinner />;
  }

  return (
    <RetailerDetails
      {...props}
      shouldDisplayTiktokStatus={isConnectionStatusToggleEnabled && isTikTokIntegration}
      isTikTokIntegration={isTikTokIntegration}
      brandIdMapping={brandIdMapping}
      key={retailer.id}
    />
  );
}

const mapStateToProps = ({ retailer, role, warehouses: supplierWarehouses }) => {
  const { isLoading, current, warehouses } = retailer;
  const {
    retailer: currentRetailer,
    inventory_buffer,
    max_inventory_visible,
    approved_warehouses,
    retailer_id_in_source,
    account_id_types,
    replenishment_shipper_account,
    replenishment_shipper_account_type,
    account_id_config: currentAccountIdConfig,
  } = current;

  const isTikTokIntegration = currentRetailer?.ecommerce_products_integration_type === CHANNELS.TIKTOK;
  const brandIdMapping = isTikTokIntegration ? current.additional_data?.products?.brandIdMapping : null;

  return {
    retailer: currentRetailer,
    buffer: inventory_buffer,
    warehouses,
    approved_warehouses,
    retailer_id_in_source,
    account_id_types,
    replenishment_shipper_account,
    replenishment_shipper_account_type,
    max_inventory_visible,
    isLoading,
    userRole: role.roles.role,
    supplierId: role.supplierId,
    supplierWarehouses: supplierWarehouses.data,
    accountIdConfig: currentAccountIdConfig,
    isTikTokIntegration,
    connectionStatus: currentRetailer?.connection_status || DISABLED,
    brandIdMapping: brandIdMapping ?? {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  putPermissions: (id, data) => dispatch(putPermissions(id, data)),
  saveErpId: (data, id) => dispatch(postRetailerErpId(data, id)),
  updateShipperAccount: (data) => dispatch(updateShipperAccount(data)),
  updateAccountIdConfig: ({ supplierId, retailerId, data }) =>
    dispatch(updateAccountIdConfig({ supplierId, retailerId, accountIdConfig: data })),
  toastSuccess: (message) => dispatch(alertSuccess(message)),
  getWarehouses: () => dispatch(getWarehouses()),
  toggleTiktokStatus: (status, retailerId, supplierId) => dispatch(toggleTiktokStatus(status, retailerId, supplierId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailerDetailsContainer);

RetailerDetailsContainer.propTypes = {
  retailer: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  supplierId: PropTypes.number.isRequired,
  getWarehouses: PropTypes.func.isRequired,
  isTikTokIntegration: PropTypes.bool.isRequired,
  brandIdMapping: PropTypes.object,
};
